const Button = ({onClick, text}) => {
    return (
        <div
            onClick={() => {
                onClick()
            }}
            style={{
                height: '48px',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0px 80px',
                background: '#4E61FF',
                cursor: "pointer"
            }}
        >
            <span
                style={{
                    color: '#FFFFFF', // var(--White) 폴백 컬러
                    fontFamily: 'Pretendard',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: '1.0',
                    letterSpacing: '-0.5px',
                }}
            >
                {text}
            </span>

        </div>  
    )
}

export default Button;